export default __webpack_public_path__ + "static/media/pkb-8.f81c19cc.png";